/**
 * Blocked reasons for the staff screens that are composed or shared between
 * two of them — «[why]. [what to do].». A reason used by one button only
 * stays beside it; a reason two features share goes in `lib/reasons.ts`.
 */

/**
 * Why a role card in the invite dialog cannot be picked: the grant ceiling
 * (`GRANT_CEILING_REASON`'s rule), with the permissions named — the inviter
 * cannot hand out a role holding keys they do not hold themselves.
 */
export function blockedRoleReason(missing: readonly string[]): string {
  return `این نقش دسترسی «${missing.join('، ')}» رو داره که خودتون ندارید. از مالک کلینیک بخواید این دعوت رو بفرسته.`;
}

/** «ذخیرهٔ دسترسی‌ها» before the role list has loaded (the Alert above offers a retry). */
export const OVERRIDES_ROLE_UNKNOWN_REASON =
  'فهرست نقش‌ها هنوز بارگذاری نشده. «تلاش دوباره» رو در کادر بالا بزنید و بعد ذخیره کنید.';

/** «ذخیرهٔ دسترسی‌ها» while the change grants a key the editor does not hold. */
export const OVERRIDES_ESCALATION_REASON =
  'این تغییر دسترسی‌ای اضافه می‌کنه که خودتون ندارید. اون رو بردارید یا از مالک کلینیک بخواید این تغییر رو ذخیره کنه.';

/** «ذخیرهٔ برنامهٔ هفتگی» while a shift row is invalid (coloured, and listed in the Alert above). */
export const SCHEDULE_INVALID_REASON =
  'بعضی شیفت‌ها درست نیستند. ردیف‌های رنگی رو درست کنید و بعد ذخیره کنید.';
